// Home banner slider Script //
$(".main_slider").slick({
    dots: true,
    arrows: false,
    pauseOnHover: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: false,
          arrows: true,
          adaptiveHeight: true,
        },
      },
    ],
  });
  
  $('.happy_faces').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 2000, 
});
 

/***** Navbar fixed js *****/
$(window).scroll(function() {
  if ($(this).scrollTop() > 1){  
    $('header').addClass("sticky");
  }
  else{
    $('header').removeClass("sticky");
  }
});
 
$(document).ready(function(){

  // Open sidebar
  $(".humbergur_menu").click(function(){
    $("#myNavbar").addClass("open_navbar");
    $("body").addClass("nav_open");
  });

  // Close when clicking on close icon
  $(".close_icon").click(function(){
    closeSidebar();
  });

  // Close when clicking outside the sidebar
  $(".body_overlay").click(function(){
    closeSidebar();
  });

  function closeSidebar(){
    $("#myNavbar").removeClass("open_navbar");
    $("body").removeClass("nav_open");
  }

});

// $(document).ready(function(){
//   $(".humbergur_menu").click(function(){
//     $("#myNavbar").addClass("open_navbar");
//   });
//   $(".close_icon").click(function(){
//     $("#myNavbar").removeClass("open_navbar");
//   });
// });

// $(window).load(function() {
//     $('#carousel').flexslider({
//       animation: "slide",
//       controlNav: false,
//       animationLoop: false,
//       slideshow: false,
//       itemWidth: 76,
//       itemMargin: 8,
//       asNavFor: '#slider'
//     });
 
//     $('#slider').flexslider({
//       animation: "slide",
//       controlNav: false,
//       animationLoop: false,
//       slideshow: false,
//       sync: "#carousel"
//     });

// });


const headers = document.querySelectorAll(".accordion-header");
headers.forEach(header => {
    header.addEventListener("click", () => {
        const openItem = document.querySelector(".accordion-header.active");
        if (openItem && openItem !== header) {
            openItem.classList.remove("active");
            const openContent = openItem.nextElementSibling;
            openContent.style.maxHeight = null;
            openContent.classList.remove("show");
        }
        header.classList.toggle("active");
        const content = header.nextElementSibling;
        if (header.classList.contains("active")) {
            content.style.maxHeight = content.scrollHeight + "px";
            content.classList.add("show");
        } else {
            content.style.maxHeight = null;
            content.classList.remove("show");
        }
    });
});
// SHOP EVOLVED CLASSICS button hover fix
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    document.querySelectorAll('a.custom_btn[href*="cookie-collections"]').forEach(function(btn) {
      btn.addEventListener('mouseenter', function() {
        this.style.setProperty('background-color', '#F9EAD8', 'important');
        this.style.setProperty('border-color', '#C69B1A', 'important');
        this.style.setProperty('color', '#6F4A1E', 'important');
      });
      btn.addEventListener('mouseleave', function() {
        this.style.setProperty('background-color', '#F9EAD8', 'important');
        this.style.setProperty('border-color', '#C69B1A', 'important');
        this.style.setProperty('color', '#6F4A1E', 'important');
      });
    });
  }, 1000);
});
 